<script setup lang="ts">
import {getting} from "@/Composables/api";
import {PageLoading} from "@/Components/Global";
import StimulusItem from "../../Stimuli/StimulusItem.vue";

const props = defineProps<{stimuli: any}>();
const model = defineModel();
</script>
<template>
    <div>
        <PageLoading v-if="getting.includes('stimuli')" />
        <div
            v-if="!getting.includes('stimuli') && stimuli.length"
            class="grid grid-cols-2 gap-3 md:grid-cols-3"
            v-auto-animate
        >
            <!--            <button-->
            <!--                type="button"-->
            <!--                @click="model = 0"-->
            <!--                class="rounded-md border bg-stone-50 !p-6 font-semibold shadow-sm transition hover:bg-stone-100 hover:bg-stone-800 dark:border-stone-700 dark:bg-stone-900"-->
            <!--            >-->
            <!--                No stimulus-->
            <!--            </button>-->
            <template v-for="stimulus in stimuli" :key="stimulus.id">
                <button type="button" @click="model = stimulus.id" class="block h-full grow">
                    <StimulusItem :stimulus="stimulus" />
                </button>
            </template>
        </div>
        <div v-else-if="!getting" class="flex flex-col items-stretch">
            <p class="mb-2 mt-4 text-center">No stimuli found.</p>
        </div>
    </div>
</template>
<style scoped></style>
